import { render, staticRenderFns } from "./Job.vue?vue&type=template&id=0da5c588&scoped=true"
import script from "./Job.vue?vue&type=script&lang=js"
export * from "./Job.vue?vue&type=script&lang=js"
import style0 from "./Job.vue?vue&type=style&index=0&id=0da5c588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5c588",
  null
  
)

export default component.exports